import axios from './index';
var regex = /^\d+$/;
class TicketApi {
  static List = (data) => {
    let query = '?';
    if (data.searchTerm) {
      query += regex.test(data.searchTerm)
        ? `phone_number=${data.searchTerm}&`
        : `search=${data.searchTerm}&`;
    }

    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    if (data.statusFilter) {
      query += `status=${data.statusFilter}&`;
    }
    if (data.priorityFilter) {
      query += `priority=${data.priorityFilter}&`;
    }
    if (data.customerId) {
      console.log('Data customerID', data.customerId);
      query += `user_id=${data.customerId}&`;
    }
    return axios.get(`${base}/${query}`);
  };

  static Create = (data) => {
    let request = {
      subject: data.subject,
      message: data.message,
      phone_number: data.phone_number,
      priority: data.priority,
      status: data.status,
    };
    return axios.post(`${base}/`, request);
  };

  static Update = (data) => {
    console.log('data :: ', data);
    let request = {
      subject: data.subject,
      message: data.message,
      phone_number: data.phone_number,
      priority: data.priority,
      status: data.status,
    };
    if (data.status) request.status = data.status;
    return axios.put(`${base}/${data.id}`, request);
  };

  static Delete = (data) => {
    return axios.delete(`${base}/${data.id}`);
  };
}

let base = 'dashboard/ticket';

export default TicketApi;
